import { UserLoan } from '@matech/thebigpos-sdk'

export const filterUserLoansByRoles = (
	userLoans: UserLoan[],
	roles: UserLoan['role'][]
) => {
	if (!userLoans) return []
	return userLoans.filter((userLoan) => {
		const userRole = userLoan.role
		return roles.includes(userRole)
	})
}

export const truncatedUserLoans = (userLoans: UserLoan[]) => {
	const remaining = 0
	if (userLoans.length > 1) {
		return {
			userLoans: userLoans.slice(0, 1),
			remaining: userLoans.length - 1,
		}
	}

	return { userLoans, remaining }
}

export const addSpacesToPascalCase = (str: string) => {
	return str.replace(/([a-z])([A-Z])/g, '$1 $2')
}

export const getNameExtensionFromFileName: (fileName: string) => {
	name: string
	extension: string
} = (fileName: string) => {
	const fileNameToArray = fileName.split('.')
	const extension =
		fileNameToArray.length > 1 ? fileNameToArray.pop() ?? '' : ''
	const name = fileNameToArray.join('_') // Join with underscore to avoid issues with extra periods in file names

	return { name, extension }
}
